<div data-test="quizLabelsElement" [formGroup]="form">

    <div formArrayName="options">

        <ng-container *ngFor="let optionControl of optionsArray.controls; let i = index;">
            <app-quiz-label
                data-test="appQuizLabel" 
                [mode]="mode"
                [formControl]="optionControl"
                [option]="(quizLabels$ | async)[i]"
                [options]="quizLabels$ | async"
                [sequence]="i + 1"
                [correct]="isCorrect((quizLabels$ | async)[i], activeSubmitted, i)"
                (labelUpdated)="handleLabelUpdated($event, i)"
                [collapsed]="labelsCollapsed$ | async">
            </app-quiz-label>
        </ng-container>

    </div>

</div>
